// @flow

import React from 'react';

const AgreeToTOCLine = () => {
  return (
    <span style={{}}>
      {'I agree to the '}<a
        href='https://askneo.io/tos/'
        target='_blank'
        rel='noopener noreferrer'
      >{'Terms & Conditions'}</a>{' and '}<a
        href='https://askneo.io/privacy/'
        target='_blank'
        rel='noopener noreferrer'
      >{'Privacy Policy'}</a>{'.'}
  </span>
  );
};

export default AgreeToTOCLine;